// extracted by mini-css-extract-plugin
module.exports = {"banner":"ElectronicCopyBanner_banner__mWwwg","icon":"ElectronicCopyBanner_icon__wjqf1","text":"ElectronicCopyBanner_text__JAobB"};